import React from "react";
import QuestionListItem from "./question-item";
import * as Icon from "react-feather";
import { compare } from "../helpers/index.js";
import * as M from "@material-ui/core";

import { observer, inject } from "mobx-react";

const QuestionList = ({ mode, store }) => {
  const isValid = key => {
    let count = 0;
    let question = store.$question.list.get(key);
    question.childrenRecursive &&
      question.childrenRecursive.forEach(child => {
        const field = document.querySelector("#\\" + child._key + " input");
        field && store.$validation.getValidityKey(field) && count++;
      });
    return count ? false : true;
  };

  const { $survey, $alert, $validation, $user, $locale, $group, $question, $config } = store;

  return (
    <React.Fragment>
      {$validation.list.size > 0 && (
        <div className="bg-red color-white p-4 border-radius mb-4">
          {$locale.t("validation_globaleMessage")}
        </div>
      )}

      <div className="show-for-print mb-4">
        <h1 className="mb-4">
          {$locale.t($survey.selected._key + "_surveyName") || $survey.selected.name} (
          {$locale.getLanguageLabelForKey($locale.activeLocale, "NL")})
        </h1>
        <br />
        <br />
        <br />
      </div>

      {$survey.selected.questionTree.map((question, i) => (
        <QuestionListItemContainer
          question={$question.list.get(question._key)}
          key={question._key}
          store={store}
          order={i + 1}
        />
      ))}

      {mode !== "view" &&
        ($user.sessionUser.isVerifiedCreator || $survey.selected.questions_for_group) && (
          <div className="hide-for-print">
            <M.Button
              startIcon={<Icon.Plus className="color-white" />}
              onClick={() =>
                $question.setSelected({
                  _key: "new",
                  type: "fieldset",
                  surveyKey: $survey.selected._key,
                  createdBy: $user.sessionUser._key,
                  createdForGroup: $survey.selected.questions_for_group
                    ? $group.selected && $group.selected._key
                    : null,
                  parentKey: null,
                  order: ($survey.selected.questionTree.length + 1) * 100
                })
              }
            >
              {"Nieuw " + $config.getLabelForFieldType("fieldset")}
            </M.Button>
          </div>
        )}

      {$validation.list.size > 0 && (
        <div className="bg-red color-white p-4 border-radius mb-8">
          {$locale.t("validation_globaleMessage")}
        </div>
      )}

      {mode === "view" && (
        <div className="flex justify-between mt3">
          <M.Button
            disabled={!$survey.selected._activeQuestion}
            startIcon={<Icon.ArrowLeft />}
            onClick={$survey.selected.prevActiveQuestion}
          >
            {$locale.t("previous")}
          </M.Button>
          <div className="flex items-center">
            {$survey.selected.questionTree.map((q, i) => (
              <span
                key={i}
                onClick={() => {
                  window.scrollTo(0, 0);
                  $survey.selected._activeQuestion > i &&
                    $survey.selected.change("_activeQuestion", i);
                }}
                className={`step ${$survey.selected._activeQuestion === i && "active"} ${
                  $survey.selected._activeQuestion > i && "completed"
                } ${$survey.selected._activeQuestion > i && "pointer"} ${
                  $survey.selected._activeQuestion > i && !isValid(q._key) ? "invalid" : ""
                }`}
              >
                {!isValid(q._key) && $survey.selected._activeQuestion > i ? "!" : i + 1}
              </span>
            ))}
          </div>
          {$survey.selected.getActiveQuestionKey($survey.selected._activeQuestion + 1) && (
            <M.Button endIcon={<Icon.ArrowRight />} onClick={$survey.selected.nextActiveQuestion}>
              {$locale.t("next")}
            </M.Button>
          )}
          {!$survey.selected.getActiveQuestionKey($survey.selected._activeQuestion + 1) && (
            <M.Button
              color="secondary"
              disabled={$alert.list.size > 0 || $validation.list.size > 0}
              onClick={$survey.selected.submitAnswers}
            >
              {$locale.t("send")}
            </M.Button>
          )}
        </div>
      )}

      {$question.openDragDialog && <DragFieldsetDialog />}

      <M.Dialog
        open={Boolean($question.confirmDeleteQuestion)}
        onClose={() => $question.change("confirmDeleteQuestion", "")}
      >
        <M.DialogTitle>Let op!</M.DialogTitle>
        <M.DialogContent>{`De vraag "${$locale.t(
          $question.confirmDeleteQuestion
        )}" heeft reeds inzendingen! Weet u zeker dat u deze wilt verwijderen?`}</M.DialogContent>
        <M.DialogActions>
          <M.Button
            variant="outlined"
            onClick={() => $question.change("confirmDeleteQuestion", "")}
          >
            Annuleren
          </M.Button>
          <M.Button
            onClick={e => {
              $question.list.get($question.confirmDeleteQuestion).fsDelete();
              $question.change("confirmDeleteQuestion", "");
            }}
          >
            Verwijderen
          </M.Button>
        </M.DialogActions>
      </M.Dialog>
    </React.Fragment>
  );
};

const QuestionListItemContainer = observer(({ question, store, order }) => {
  const { $question, $survey, $user } = store;

  return (
    <div
      className={questionClasses(question, store, order)}
      draggable={question.draggable}
      onDragStart={e => {
        if (!question.children.length) {
          $question.change("dragFrom", question._key);
        }
      }}
      onDragOver={e => {
        e.preventDefault();
        if (!question.children.length && $question.dragFrom) {
          question.handleDragOver($question.dragFrom, question._key);
        }
      }}
      onDrop={e => {
        e.preventDefault();
        if (!question.children.length) {
          question.updateSiblingsAfter();
          $question.change("dragFrom", null);
        }
      }}
    >
      {$question.list.has(question._key) && (
        <QuestionListItem question={$question.list.get(question._key)} order={order} />
      )}

      {/*sort hier laten staan anders werkt het niet*/}
      {question.children.sort(compare("order", "asc")).map((child, k) => (
        <QuestionListItemContainer
          key={child._key}
          store={store}
          question={$question.list.get(child._key)}
          order={k + 1}
        />
      ))}
      {question.isEditable && $user.sessionUser.isVerifiedCreator && question._level < 1 && (
        <div className="hide-for-print mt-4">
          <M.Button
            startIcon={<Icon.Plus className="color-white" />}
            onClick={() =>
              $question.setSelected({
                _key: "new",
                type: "fieldset",
                surveyKey: $survey.selected._key,
                createdBy: $user.sessionUser._key,
                parentKey: question._key,
                order: (question.children.length + 1) * 100
              })
            }
          >
            {"Nieuw subthema"}
          </M.Button>
        </div>
      )}
    </div>
  );
});

const DragFieldsetDialog = inject("store")(
  observer(({ store }) => {
    const { $question, $locale } = store;
    return (
      <M.Dialog open={true} fullWidth maxWidth="sm">
        <M.DialogTitle>{"Verplaats secties"}</M.DialogTitle>
        <M.DialogContent>
          {$question.list
            .get($question.openDragDialog)
            .siblings.sort(compare("order", "asc"))
            .map((q, i) => (
              <div
                className={`question-container p-3 question-fieldset pointer justify-between flex draggable ${
                  $question.dragFrom === q._key && "dragging"
                }`}
                style={i ? { boxShadow: "none" } : { boxShadow: "none" }}
                draggable={q.draggable}
                onDragStart={e => $question.change("dragFrom", q._key)}
                onDragOver={e => {
                  e.preventDefault();
                  if ($question.dragFrom) {
                    $question.change("dragTo", q._key);
                    q.handleDragOver($question.dragFrom, q._key);
                  }
                }}
                onDrop={e => {
                  e.preventDefault();
                  $question.list.get($question.dragFrom).fsSave();
                  $question.list.get($question.dragTo).fsSave();
                  $question.change("dragTo", null);
                  $question.change("dragFrom", null);
                }}
                key={q._key}
              >
                {$locale.t(q._key)}
                {q.draggable && <Icon.Move size={18} />}
              </div>
            ))}
        </M.DialogContent>
        <M.DialogActions>
          <M.Button onClick={() => $question.change("openDragDialog", null)}>OK</M.Button>
        </M.DialogActions>
      </M.Dialog>
    );
  })
);

const questionClasses = (question, store, order) => {
  const { $question, $router, $survey } = store;

  const classes = ["question-container", "mb-8", question._key, "question-" + question.type];

  if (question._hidden) classes.push("hidden");
  if (
    question.type === "fieldset" &&
    (question.level === 0 || question._level === 1) &&
    order !== 1
  )
    classes.push("pagebreak");
  if (question._level === 0) classes.push("question-fieldset");
  if (question.draggable) classes.push("draggable");
  if ($question.dragFrom && $question.dragFrom === question._key) classes.push("dragging");
  if (
    $router.mode === "view" &&
    question._level === 0 &&
    question._key !== $survey.selected.getActiveQuestionKey($survey.selected._activeQuestion)
  )
    classes.push("hidden");

  return [...new Set(classes)].join(" ");
};

export default inject("store")(observer(QuestionList));
